import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const useFormValidation = (formData) => {
  const [isFormValid, setIsFormValid] = useState(false);
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.(com|org|net|edu|gov|co|io|us|ca|uk)$/i;
    return emailRegex.test(email);
  };

  const validateConfirmPassword = (password, confirmPassword) => password === confirmPassword;

  useEffect(() => {
    const validatePassword = (password) => {
      const passwordErrors = [];

      if (!/.{8,}/.test(password)) {
        passwordErrors.push(t("passwordLength"));
      }
      if (!/[a-z]/.test(password)) {
        passwordErrors.push(t("passwordLowercase"));
      }
      if (!/[A-Z]/.test(password)) {
        passwordErrors.push(t("passwordUppercase"));
      }
      if (!/\d/.test(password)) {
        passwordErrors.push(t("passwordNumber"));
      }
      if (!/[@$!%*?&.\-#]/.test(password)) {
        passwordErrors.push(t("passwordSpecial"));
      }

      return passwordErrors;
    };

    const { email, password, confirmPassword } = formData;
    const newErrors = {};

    if (email && !validateEmail(email)) {
      newErrors.email = t("invalidEmail");
    }

    if (password) {
      const passwordValidationErrors = validatePassword(password);
      if (passwordValidationErrors.length > 0) {
        newErrors.password = passwordValidationErrors;
      }
    }

    if (password && confirmPassword && !validateConfirmPassword(password, confirmPassword)) {
      newErrors.confirmPassword = t("passwordsDoNotMatch");
    }

    setErrors(newErrors);
    setIsFormValid(Object.keys(newErrors).length === 0);
  }, [formData, t]);

  return { isFormValid, errors };
};

export default useFormValidation;
